import React, {Component} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import EligibilityStatusIndicator from "./EligibilityStatusIndicator";

export default class InsuranceIcon extends Component {

    static defaultProps = {
        insuranceExists: null,
        isCustomInsurance: null,
        eligibilityStatus: null,
    };

    static propTypes = {
        insuranceExists: PropTypes.string,
        isCustomInsurance: PropTypes.bool,
        eligibilityStatus: PropTypes.string,
    };

    render() {
        const {insuranceExists, isCustomInsurance, eligibilityStatus} = this.props;

        if(!insuranceExists)
            return null;

        const color = isCustomInsurance != true ? "2ECC71" : "E74C3C";

        return (
            isCustomInsurance != null ?
            <div style={{display: "flex", flexDirection: "row", alignItems: "center", gap: "8px"}}>
                <FontAwesomeIcon icon={["fas", "umbrella"]} size="2x"
                                 style={{color: color, maxHeight: "20px"}}/>
                <EligibilityStatusIndicator eligibilityStatus={eligibilityStatus}/>
            </div> : null
        );
    }

}